import React, { useContext } from "react";
import { WorkshopContext } from "../../contexts/workshop.context";
import Button from "./button";

const ParticipantsStatus = ({
  heading,
  readyParticipants = [],
  badgeText = "",
  isReady = false,
  isModerator = false,
  onReadyClick = null,
  variant = "1"
}) => {
  const { connectedUsers } = useContext(WorkshopContext);

  // Calculate lengths of the participant arrays
  const readyCount = readyParticipants.length;
  const totalCount = connectedUsers.length;

  return variant === "1" ? (
    <Varient1
      heading={heading}
      readyCount={readyCount}
      totalCount={totalCount}
      badgeText={badgeText}
    />
  ) : (
    <Varient2
      heading={heading}
      readyCount={readyCount}
      totalCount={totalCount}
      badgeText={badgeText}
      isReady={isReady}
      isModerator={isModerator}
      onReadyClick={onReadyClick}
    />
  );
};

export default ParticipantsStatus;

const Varient1 = ({ heading, readyCount, totalCount, badgeText }) => {
  return (
    <div
      className={`relative w-full rounded-2xl bg-white-100 border border-gray-750 px-2 py-4 my-6`}>
      <div className="flex items-start justify-between">
        {heading && (
          <p
            className={`text-xl mb-4 flex gap-2 font-bold`}
            dangerouslySetInnerHTML={{ __html: heading }}
          />
        )}
      </div>
      <div className="flex items-start justify-between">
        <p className={`text-xl font-bold px-4 py-1`}>{`${readyCount}/${totalCount}`}</p>
        <p className={`text-xl rounded-full bg-emerald-200 px-4 py-1`}>{badgeText}</p>
      </div>
    </div>
  );
};

const Varient2 = ({
  heading,
  readyCount,
  totalCount,
  badgeText,
  isReady,
  isModerator,
  onReadyClick
}) => {
  return (
    <div className="relative w-full rounded-2xl bg-orange-50 border border-gray-750 px-2 py-2 my-2">
      <div className="flex justify-between items-center">
        <div className="flex flex-col items-start gap-2">
          {heading && (
            <p className="text-xl flex font-bold" dangerouslySetInnerHTML={{ __html: heading }} />
          )}
          <p className="text-xl font-bold px-4 py-1">{`${readyCount}/${totalCount}`}</p>
        </div>
        {isReady || isModerator ? (
          <p className="text-xl rounded-full bg-emerald-200 px-4 py-1">{badgeText}</p>
        ) : (
          onReadyClick && <Button text={badgeText} type="rounded" onClick={onReadyClick} />
        )}
      </div>
    </div>
  );
};
